import React, {
  useState,
  useMemo,
  Fragment,
  memo,
  useEffect,
  useRef,
} from "react";
import _, { isArray } from "lodash";
import { useTable, useRowSelect } from "react-table";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import classNames from "classnames";
import { format, differenceInDays } from "date-fns";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import {
  faAngleUp,
  faAngleDown,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingMutation from "../Loading/LoadingMutation";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import font from "../../styles/Sarabun-Regular.ttf";
import fontBold from "../../styles/Sarabun-Bold.ttf";

// UTILS
import { getCurrentLocalDateTime, months } from "../../utils/getLocalDateTime";

// REDUX
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// OTHER
import numeral from "numeral";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DARK } from "@blueprintjs/core/lib/esm/common/classes";
import { getDetailSegment } from "utils/buro";
import { ModalDialog } from "components/LoanSandbox/LoanSandboxId";

const IndeterminateCheckbox = React.forwardRef(
  ({ onChange, id, selectedFlatRows, flatRows, ...rest }, ref) => {
    useEffect(() => {
      const getIdAll = document.getElementById("ALL");
      if (selectedFlatRows?.length > 0) {
        const newRows = flatRows
          .map((row) => {
            return row;
          })
          .filter((row) => row);
        getIdAll.checked = newRows.length === selectedFlatRows.length;
        getIdAll.indeterminate = newRows.length !== selectedFlatRows.length;
        return;
      }
      getIdAll.indeterminate = false;
      getIdAll.checked = false;
    }, [selectedFlatRows]);

    return (
      <>
        <input
          type="checkbox"
          id={id}
          onChange={onChange}
          {...rest}
          style={{ width: "20px", height: "20px" }}
        />
      </>
    );
  }
);

const Row = memo(({ row, i, value, getData, query, paid_date }) => {
  const { user } = useSelector((state) => state.initializeApp);

  const onClickRoute = () => {
    const { loan_id } = value;
    window.open(`/LoanSandbox/${loan_id}`, "_blank");
  };

  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        onClick={onClickRoute}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 text-xs text-center"}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
    </Fragment>
  );
});

Font.register({ family: "Sarabun", fonts: [{ src: font }, { src: fontBold }] });
// Font.register({
//   family: "Roboto",
//   src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
// });

var isProcessing = false;

const styles = StyleSheet.create({
  page: {
    fontFamily: "Sarabun",
    padding: 24,
    fontSize: 12,
    backgroundColor: "#fff",
  },
  content: {
    paddingHorizontal: 16,
    // textIndent: 18
  },
  date: {
    marginTop: 3,
    marginBottom: 20,
    textAlign: "center",
  },
  header: {
    fontSize: 12,
    textAlign: "center",
  },
  text: {
    margin: 12,
    fontSize: 12,
    lineHeight: 1.6,
    // marginVertical: 4,
    // fontSize: 12,
    fontFamily: "Sarabun",
  },
  textContent: {
    maginTop: 18,
    marginBottom: 18,
    lineHeight: 1.6,
    fontFamily: "Sarabun",
  },
  bold: {
    fontFamily: "Sarabun",
    fontWeight: "bold",
    lineHeight: 1.6,
  },
  address: {
    textAlign: "right",
    marginVertical: 16,
  },
});

const getNumberText = (value, concat = "") => {
  if (value % 10 >= 9) return "เก้า" + concat;
  if (value % 10 >= 8) return "แปด" + concat;
  if (value % 10 >= 7) return "เจ็ด" + concat;
  if (value % 10 >= 6) return "หก" + concat;
  if (value % 10 >= 5) return "ห้า" + concat;
  if (value % 10 >= 4) return "สี่" + concat;
  if (value % 10 >= 3) return "สาม" + concat;
  if (value % 10 >= 2) return "สอง" + concat;
  if (value % 10 >= 1) return "หนึ่ง" + concat;
  return "";
};

const getThaiAmount = (value = 1819) => {
  var grand = value / 10000;
  var thounsand = value / 1000;
  var hundred = value / 100;
  var deci = value / 10;
  var last = value % 10;
  var lastText = getNumberText(last);
  var deciText = getNumberText(deci, "สิบ");
  if (deci >= 1 && deci < 2) deciText = "สิบ";
  if (deci == 2) deciText = "ยี่สิบ";
  var hundredText = getNumberText(hundred, "ร้อย");
  var thounsandText = getNumberText(thounsand, "พัน");
  var grandText = getNumberText(grand, "หมื่น");
  if (last === 1) lastText = "เอ็ด";

  let prefix = grandText + thounsandText + hundredText + deciText + lastText;
  if (value <= 0) {
    prefix = "ศูนย์";
  }

  return prefix + "บาทถ้วน";
};

const PdfDocument = ({ row, isFirst = false, interests }) => {
  const {
    name,
    lastname,
    loan_kbank_id,
    requestTime,
    overdue_date,
    installments,
    interestMore,
    requestamount,
    type,
  } = row.original;

  console.log("ROW", row);

  const currentInterest = interests.find((interest) => interest.type === type);

  const fullname = `${name} ${lastname}`;

  var now_th = moment.locale("th");
  var today = moment().add(543, "year").format("DD/MM/YYYY");
  var currentDate = moment().date();
  var currentYear = moment().add(543, "year").year();
  var rawMonth = moment().format("MM");
  var currentMonth = "มกราคม";
  if (rawMonth == "02") currentMonth = "กุมภาพันธ์";
  if (rawMonth == "03") currentMonth = "มีนาคม";
  if (rawMonth == "04") currentMonth = "เมษายน";
  if (rawMonth == "05") currentMonth = "พฤษภาคม";
  if (rawMonth == "06") currentMonth = "มิถุนายน";
  if (rawMonth == "07") currentMonth = "กรกฎาคม";
  if (rawMonth == "08") currentMonth = "สิงหาคม";
  if (rawMonth == "09") currentMonth = "กันยายน";
  if (rawMonth == "10") currentMonth = "ตุลาคม";
  if (rawMonth == "11") currentMonth = "พฤศจิกายน";
  if (rawMonth == "12") currentMonth = "ธันวาคม";

  const convertRequestTime = getCurrentLocalDateTime(new Date(requestTime));
  const overdueDate = getCurrentLocalDateTime(new Date(overdue_date));
  const owedDue =
    installments
      .filter(
        (installment) => installment.date < format(new Date(), "yyyy-MM-dd")
      )
      .reduce((prev, installment) => {
        return prev + installment.actualPrinciple;
      }, 0) + interestMore;

  var previousYear = Number(currentYear) - 1;
  var header = "หนังสือแจ้งรายปีฉบับที่";
  if (isFirst) {
    header = "หนังสือแจ้งครั้งแรกฉบับที่";
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}>
          หนังสือบอกกล่าวทวงถามให้ชำระนี้ครั้งที่ {isFirst ? "1" : "2"}{" "}
        </Text>
        <View style={styles.content}>
          <View style={styles.address}>
            <Text>
              ทำที่ 1010 อาคารชินวัตรทาวเวอร์ 3 ชั้นที่ 12 ถนนวิภาวดีรังสิต{" "}
            </Text>
            <Text>แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร </Text>
          </View>

          <View style={styles.date}>
            <Text>
              วันที่ {currentDate} เดือน {currentMonth} ปี {currentYear}
            </Text>
          </View>

          <View style={{ maginTop: 16, marginBottom: 16 }}>
            <Text style={styles.textContent}>
              <Text style={styles.bold}>เรียน</Text>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Text style={styles.text}>คุณ {fullname} </Text>
              <Text style={styles.bold}>("ผู้กู้")</Text>
            </Text>

            <Text style={styles.textContent}>
              <Text style={styles.bold}>เรื่อง</Text>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Text style={styles.text}>
                ขอให้ชำระหนี้ค้างชำระตามสัญญาสินเชื่อ{" "}
              </Text>
            </Text>

            <Text style={styles.textContent}>
              <Text style={styles.bold}>อ้างถึง</Text>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Text style={{ ...styles.text }}>
                สัญญาสินเชื่อ เลขที่ {loan_kbank_id} ฉบับลงวันที่{" "}
                {convertRequestTime.date}{" "}
                {months[convertRequestTime.monthIndex].monthTh}{" "}
                {+convertRequestTime.year + 543} ระหว่าง ผู้กู้ และ บริษัท
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;มันนี่
                ฮับ เซอร์วิส จำกัด ("บริษัท" หรือ "ผู้ให้กู้") ("สัญญาสินเชื่อ"){" "}
              </Text>
            </Text>
          </View>

          <Text style={{ ...styles.textContent, textAlign: "left" }}>
            <Text style={styles.bold}>สิ่งที่ส่งมาด้วย&nbsp;</Text>
            <Text>
              &nbsp;&nbsp;ใบแจ้งยอดรายการและภาระหนี้ ฉบับลงวันที่{" "}
              {overdueDate.date}
              &nbsp;
              {months[overdueDate.monthIndex].monthTh}&nbsp;
              {+overdueDate.year + 543} ออกโดยบริษัท ถึง ผู้กู้{" "}
            </Text>
            <Text>
              (แสดงภาระหนี้ค้างชำระรวมเป็นเงินจำนวนทั้งสิ้น&nbsp;
              {owedDue} บาท ทั้งนี้ หนี้ค้างชำระดังกล่าวยังไม่รวมค่าใช้จ่ายใดๆ
              ในการดำเนินการติดตามทวงถามหนี้){" "}
            </Text>
          </Text>

          <Text
            style={{
              ...styles.textContent,
              textAlign: "justify",
            }}
          >
            <Text style={{ textIndent: 30 }}>
              ตามสัญญาสินเชื่อที่อ้างถึง ท่าน ในฐานะผู้กู้
              ได้เข้าทำสัญญาสินเชื่อกับบริษัท มันนี่ ฮับ เซอร์วิส{" "}
            </Text>
            <Text>
              จำกัด ในฐานะผู้ให้กู้ และกู้ยืมเงินไปจากบริษัท ในฐานะผู้ให้กู้
              เป็นเงินจำนวน {requestamount} บาท{" "}
            </Text>
            <Text>
              ({getThaiAmount(requestamount)})
              โดยท่านตกลงชำระดอกเบี้ยในอัตราร้อยละ {currentInterest.value}%
              ต่อปีของต้นเงินดังกล่าว{" "}
            </Text>
            <Text>รายละเอียดปรากฎตามสัญญาสินเชื่อ </Text>
          </Text>

          <Text
            style={{
              ...styles.textContent,
              textAlign: "justify",
              textIndent: 30,
            }}
          >
            <Text style={{ textIndent: 30 }}>
              บริษัทขอเรียนให้ท่านทราบว่า
              ท่านมียอดหนี้ค้างชำระตามสัญญาสินเชื่อซึ่งเลยกำหนดชำระและพึง&nbsp;&nbsp;{" "}
            </Text>
            <Text>
              ต้องชำระให้แก่บริษัท เป็นจำนวนทั้งสิ้น {owedDue} บาท (
              {getThaiAmount(owedDue)}) รายละเอียดภาระหนี้ค้าง{" "}
            </Text>
            <Text>
              ชำระและรายละเอียดการคำนวณภาระหนี้ปรากฏตามใบแจ้งยอดรายการและภาระหนี้ที่ได้แนบท้ายมากับ{" "}
            </Text>
            <Text>
              หนังสือฉบับนี้ (ทั้งนี้ หนี้ค้างชำระดังกล่าวยังไม่รวมค่าใช้จ่ายใด
              ๆ ในการดำเนินการติดตามทวงถามหนี้ ซึ่ง{" "}
            </Text>
            <Text>บริษัทจะเรียกเก็บจากท่าน (หากมี) ต่อไป) </Text>
          </Text>

          <Text
            style={{
              ...styles.textContent,
              textAlign: "justify",
              textIndent: 30,
            }}
          >
            <Text style={{ textIndent: 30 }}>
              โดยหนังสือบอกกล่าวทวงถามให้ชำระหนี้
              <Text style={styles.bold}> ("หนังสือฉบับนี้") </Text>{" "}
              บริษัทจึงเรียนมายังท่านเพื่อขอให้ท่านชำระ{" "}
            </Text>
            <Text>
              หนี้ค้างชำระจำนวนดังกล่าวทั้งหมดให้แก่บริษัทตามรูปแบบการชำระเงินและผ่านช่องทางการ
              &nbsp;&nbsp;&nbsp;
            </Text>
            <Text>
              ชำระต่างๆที่ระบุในใบแจ้งยอดรายการและภาระหนี้ที่แนบมานี้{" "}
              {isFirst ? "ภายใน 7 วัน " : "อย่างเร็วที่สุด ภายใน 3 วัน"}
              นับจากวันที่ได้รับหนังสือ{" "}
            </Text>

            <Text>
              ฉบับนี้
              <Text style={{ ...styles.bold, textDecoration: "underline" }}>
                {" "}
                หากบริษัทยังไม่ได้รับชำระหนี้จากท่านเมื่อพ้นระยะเวลาดังกล่าวแล้ว
              </Text>
              <Text style={{ ...styles.bold, textDecoration: "underline" }}>
                บริษัทมีความจำเป็นที่อาจจะ
                ต้องดำเนินการตามสัญญาและ/หรือดำเนินการบังคับชำระหนี้จากท่านตามกฎหมาย
              </Text>
              <Text style={{ ...styles.bold, textDecoration: "underline" }}>
                &nbsp;ต่อไป อนึ่ง หากท่านได้ &nbsp;&nbsp;&nbsp;
              </Text>
              <Text style={{ ...styles.bold, textDecoration: "underline" }}>
                มีการชำระหนี้ให้แก่บริษัทแล้วก่อนได้รับหนังสือฉบับนี้ &nbsp;
                บริษัทต้องขออภัยเป็นอย่างสูงมา ณ โอกาสนี้ด้วย &nbsp;
              </Text>
            </Text>
          </Text>

          <Text
            style={{
              ...styles.textContent,
              textAlign: "justify",
            }}
          >
            <Text style={{ textIndent: 30 }}>
              หากหนังสือฉบับนี้ส่งโดยจดหมายอิเล็กทรอนิกส์โดยสื่ออิเล็กทรอนิกส์หรือโดยสื่อเทคโนโลยี{" "}
            </Text>

            <Text>
              สารสนเทศประเภทอื่นก็ไม่กระทบต่อความสมบูรณ์หรือผลบังคับของหนังสือฉบับนี้
              และให้ถือว่าหนังสือ{" "}
            </Text>

            <Text>
              ฉบับนี้ที่ส่งทางจดหมายอิเล็กทรอนิกส์ โดยสื่ออิเล็กทรอนิกส์
              หรือโดยสื่อเทคโนโลยีสารสนเทศประเภท{" "}
            </Text>

            <Text>อื่นดังกล่าว เป็นต้นฉบับ </Text>
          </Text>

          <Text
            style={{
              ...styles.textContent,
              textAlign: "justify",
            }}
          >
            <Text style={{ textIndent: 30 }}>
              เมื่อท่านได้รับหนังสือฉบับนี้แล้วบริษัทขอให้ท่านตรวจสอบยอดหนี้ค้างชำระและรายละเอียดที่{" "}
            </Text>

            <Text>
              ระบุในหนังสือฉบับนี้และตามใบแจ้งยอดรายการและภาระหนี้ที่แนบท้ายหนังสือฉบับนี้หากท่านมี{" "}
            </Text>

            <Text>
              ข้อโต้แย้งหรือเรื่องร้องเรียนใดๆ กรุณาติดต่อมายังบริษัทภายใน{" "}
              {isFirst ? "7" : "3"}&nbsp;วัน{" "}
            </Text>
          </Text>

          <Text
            style={{
              ...styles.textContent,
              marginTop: 16,
              textAlign: "center",
            }}
          >
            จึงเรียนมาเพื่อโปรดดำเนินการโดยเร็ว{" "}
          </Text>

          <View
            style={{
              ...styles.textContent,
              marginTop: 24,
              textAlign: "center",
            }}
          >
            <Text>ขอแสดงความนับถือ </Text>
            <Text>ลงนามเพื่อและในนามของ </Text>
            <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด </Text>
          </View>

          <View
            style={{
              ...styles.textContent,
              marginTop: 24,
              textAlign: "center",
            }}
          >
            <Text>โดย_________________________ </Text>
            <Text>ชื่อ:_________________________ </Text>
            <Text>ตำแหน่ง: ผู้จัดการฝ่ายเร่งรัดหนี้สิน </Text>
            <Text>
              (โดยหนังสือมอบอำนาจ ฉบับลงวันที่ {currentDate} {currentMonth}{" "}
              {currentYear}){" "}
            </Text>
          </View>

          <View
            style={{
              ...styles.textContent,
              marginTop: 20,
              textAlign: "left",
            }}
          >
            <Text style={styles.bold}>หมายเหตุ : </Text>
            <Text>
              สอบถามรายละเอียดเพิ่มเติม ติดต่อศูนย์บริการลูกค้า บริษัท มันนี่
              ฮับ เซอร์วิส จำกัด{" "}
            </Text>
            <Text>
              โทร 02-791-1300 วันเวลาทำการ 08:30-17:30 น. หรือ
              ติดต่อฝ่ายเร่งรัดหนี้สิน โทร 02-791-1300{" "}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

const generatePdfDocument = async (row, isFirst = false, filename) => {
  if (isProcessing) toast.warn("กำลังทำรายการโปรดรอสักครู่");
  else isProcessing = true;

  const { body } = await API.get("MoneyHubAdmin", "/interest", {
    queryStringParameters: {},
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
    },
  });

  const interests = JSON.parse(body).Items;

  /// Cal increment Lamba to get Count here
  try {
    let blob = await pdf(
      <PdfDocument
        interests={interests}
        row={row}
        title={filename}
        isFirst={isFirst}
      />
    ).toBlob();
    saveAs(blob, filename);
    toast.success("ดาวโหลดสมบูรณ์");
    isProcessing = false;
  } catch (error) {
    alert(error);
    isProcessing = false;
  }
};

function LoanTable({
  data,
  getData,
  query,
  setSelectedRows,
  overDueDate,
  currentDate,
}) {
  const ref = useRef();
  const [openModal, setOpenModal] = useState(false);
  const [rowModal, setRowModal] = useState();
  const [search, setSearch] = useState("");
  const [oriRowModal, setOriRowModal] = useState([]);

  const onDelete = (row) => async (e) => {
    e.stopPropagation();
    await API.del("MoneyHubAdmin", `/loan/sandbox/${row.original.loan_id}`, {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });
    await getData(query);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Job. No.",
        accessor: "loan_kbank_id",
      },
      {
        Header: "EMS FIRST",
        accessor: "ems_first",
      },
      {
        Header: "EMS SECOND",
        accessor: "ems_second",
      },
      {
        Header: "ชื่อ",
        accessor: "fullname",
      },
      {
        Header: "จำนวนงวด",
        accessor: "period",
      },
      {
        Header: "ประเภทสินเชื่อ",
        accessor: "type",
      },
      {
        Header: "เงินทุน",
        accessor: "initCapital",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.initCapital).format("0,0.00")}</div>;
        },
      },
      {
        Header: "เงินต้นคงเหลือ",
        accessor: "capitalRemain",
        Cell: ({ row }) => {
          return (
            <div>{numeral(row.values.capitalRemain).format("0,0.00")}</div>
          );
        },
      },
      {
        Header: "เบอร์โทร",
        accessor: "phone_number",
      },
      {
        Header: "วันที่สร้าง",
        accessor: "requestTime",
        Cell: ({ row }) => {
          return (
            <div>{format(new Date(row.values.requestTime), "dd-MM-yyyy")}</div>
          );
        },
      },
      {
        Header: "วันที่แก้ไข",
        accessor: "executeTime",
        Cell: ({ row }) => {
          if (!row.values?.executeTime) return <div>-</div>;
          return (
            <div>{format(new Date(row.values.executeTime), "dd-MM-yyyy")}</div>
          );
        },
      },
      {
        Header: "สถานะ",
        accessor: "loan_status",
        Cell: ({ row }) => {
          const { loan_status } = row.values;
          return (
            <div
              className={classNames({
                "text-green-500": loan_status === "ACTIVE",
                "text-red-500": loan_status === "LATE",
                "text-red-500": loan_status === "FAIL",
                "text-yellow-500": loan_status === "PENDING",
                "text-purple-500": loan_status === "REFINANCE",
                "text-green-600": loan_status === "DONE",
              })}
            >
              {loan_status}
            </div>
          );
        },
      },
      {
        Header: "OverDueDate",
        accessor: "overdue_date",
        Cell: ({ row }) => {
          const { overdue_date, loan_status } = row.values;

          if (loan_status === "DONE") {
            return <div>-</div>;
          }

          const currentOverdue_date = getCurrentLocalDateTime(
            new Date(overdue_date)
          );

          const today = getCurrentLocalDateTime(new Date(overDueDate));

          const checkOverDueDate =
            currentOverdue_date.fullDate <= today.fullDate &&
            loan_status === "ACTIVE";

          return (
            <div
              className={classNames({
                "text-red-500": checkOverDueDate,
              })}
            >
              {format(new Date(row.values.overdue_date), "dd-MM-yyyy")}
            </div>
          );
        },
      },
      {
        Header: "Days",
        accessor: "overdue_date2",
        Cell: ({ row }) => {
          const { overdue_date, loan_status } = row.values;

          if (loan_status === "DONE") {
            return <div>-</div>;
          }

          const currentOverdue_date = getCurrentLocalDateTime(
            new Date(overdue_date)
          );

          const today = getCurrentLocalDateTime(new Date(overDueDate));

          const checkOverDueDate =
            currentOverdue_date.fullDate <= today.fullDate &&
            loan_status === "ACTIVE";

          return (
            <div
              className={classNames("text-sm", {
                "text-red-500": checkOverDueDate,
              })}
            >
              {checkOverDueDate
                ? `เกินกำหนด ${differenceInDays(
                    today.timestamp,
                    currentOverdue_date.timestamp
                  )} วัน`
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "Data",
        accessor: "view",
        Cell: ({ row }) => {
          return (
            <div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setRowModal(
                    getDetailSegment({
                      currentDate,
                      dataExport: [row.original],
                      showLog: true,
                    })
                  );
                  setOriRowModal(
                    getDetailSegment({
                      currentDate,
                      dataExport: [row.original],
                      showLog: true,
                    })
                  );
                  setOpenModal(true);
                }}
                className="px-3 py-2 bg-green-400 text-white rounded"
              >
                View
              </button>
            </div>
          );
        },
      },
      {
        Header: "Delete",
        accessor: "user",
        Cell: ({ row }) => {
          const [loadingSandbox, setLoadingSandbox] = useState(false);

          const onClickDeleteSandbox = async (e, loan) => {
            try {
              e.stopPropagation();
              setLoadingSandbox(true);
              await API.del(
                "MoneyHubAdmin",
                `/loan/sandbox/clone/${loan.loan_id}`,
                {
                  headers: {
                    Authorization: `Bearer ${(await Auth.currentSession())
                      .getIdToken()
                      .getJwtToken()}`,
                  },
                }
              );
              await getData(query);
            } catch (error) {
              console.log("clone to sandbox has error", error);
            } finally {
              setLoadingSandbox(false);
            }
          };

          return (
            <div>
              <button
                disabled={loadingSandbox}
                onClick={(e) => {
                  onClickDeleteSandbox(e, row.original);
                }}
                className="px-3 py-2 bg-red-400 text-white rounded"
              >
                {loadingSandbox ? "Loading..." : "Delete"}
              </button>
            </div>
          );
        },
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable({ columns, data }, useRowSelect);

  useEffect(() => {
    setSelectedRows(selectedFlatRows);
  }, [selectedFlatRows]);

  const onChangeSearch = (e) => {
    const { value } = e.target;
    setSearch(value);

    setRowModal((prev) => {
      return oriRowModal?.filter((row) => {
        return (
          row?.tag?.toLowerCase().includes(value.toLowerCase()) ||
          row?.key?.toLowerCase().includes(value.toLowerCase())
        );
      });
    });
  };

  return (
    <div className="mx-4 mb-2">
      <ModalDialog
        isSearch={true}
        search={search}
        onChangeSearch={onChangeSearch}
        title={`Debtor`}
        setModal={setOpenModal}
        modal={openModal}
        ref={ref}
        dataJson={rowModal && rowModal}
      />
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-xs font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3 text-center text-xs", {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                    <span>
                      {" "}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon icon={faAngleDown} />
                        ) : (
                          <FontAwesomeIcon icon={faAngleUp} />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  query={query}
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                  getData={getData}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LoanTable;
